import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MagazziniMoviArtStato, MagazziniMoviArtStatoLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniMoviArtStatoService extends CrudGenericsService<MagazziniMoviArtStato, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniMoviArtStato`);
    this.base = `${env.apiUrl}/api/MagazziniMoviArtStato/`;
  }

  GetAllLng(): Observable<MagazziniMoviArtStatoLng[]> {
    const u = `${this.base}GetAllLng`;
    return this.http.get<MagazziniMoviArtStatoLng[]>(u);
  }
}
